import { render } from "./PackageDataProgress.vue?vue&type=template&id=feb6696c&scoped=true"
import script from "./PackageDataProgress.vue?vue&type=script&lang=js"
export * from "./PackageDataProgress.vue?vue&type=script&lang=js"

import "./PackageDataProgress.vue?vue&type=style&index=0&id=feb6696c&scoped=true&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-feb6696c"]])

export default __exports__